import React from 'react'
import { reducer, initialState } from './reducer'

export const CostChangeInsightsGlobalContext = React.createContext({
  costChangeInsightsGlobalState: initialState,
  costChangeInsightsGlobalDispatch: () => null,
})

export const CostChangeInsightsGlobalProvider = ({ children }) => {
  const [costChangeInsightsGlobalState, costChangeInsightsGlobalDispatch] =
    React.useReducer(reducer, initialState)

  return (
    <CostChangeInsightsGlobalContext.Provider
      value={[costChangeInsightsGlobalState, costChangeInsightsGlobalDispatch]}
    >
      {children}
    </CostChangeInsightsGlobalContext.Provider>
  )
}
